/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export const DEFAULT_BROWSER_TITLE = 'ScrubPlan';

export const normalizeProjectTitleValue = (value?: string | null) => `${value || ''}`.trim();

export const formatProjectBrowserTitle = (projectName?: string | null) => {
	const normalizedProjectName = normalizeProjectTitleValue(projectName);
	return normalizedProjectName
		? `${DEFAULT_BROWSER_TITLE} - ${normalizedProjectName}`
		: DEFAULT_BROWSER_TITLE;
};

export const normalizeProjectIdValue = (value?: string | number | null) => `${value || ''}`.trim();

export const getProjectNameFromSearch = (search: string) => {
	const projectName = new URLSearchParams(search).get('projectName');
	return normalizeProjectTitleValue(projectName);
};

const getProjectIdFromProjectPath = (pathname: string, pattern: RegExp) => {
	const match = pathname.match(pattern);
	return match ? normalizeProjectIdValue(decodeURIComponent(match[1])) : '';
};

export const getProjectIdFromPathname = (pathname: string) =>
	getProjectIdFromProjectPath(pathname, /^\/project\/([^/?#]+)/) ||
	getProjectIdFromProjectPath(pathname, /^\/multi-package-interactive-review\/([^/?#]+)/) ||
	getProjectIdFromProjectPath(pathname, /^\/exclusivity-review\/([^/?#]+)/);

export const getProjectIdFromLocationParts = (pathname: string, search: string) => {
	const queryProjectId = normalizeProjectIdValue(new URLSearchParams(search).get('projectId'));
	return queryProjectId || getProjectIdFromPathname(pathname);
};
